// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: every message box grows with what is typed up to the same height, then scrolls, so the
// conversation above it stays readable. The Lexical channel composer applies the same limit in CSS
// (LexicalMessageComposer.module.css).

export const COMPOSER_MAX_LINES = 5;

/** Sizes a textarea to its text, up to `maxLines` lines; longer text scrolls inside it. */
export function fitComposerHeight(element: HTMLTextAreaElement, maxLines = COMPOSER_MAX_LINES): void {
	const style = getComputedStyle(element);
	const lineHeight = Number.parseFloat(style.lineHeight) || Number.parseFloat(style.fontSize) * 1.2;
	const padding = (Number.parseFloat(style.paddingTop) || 0) + (Number.parseFloat(style.paddingBottom) || 0);
	const border = (Number.parseFloat(style.borderTopWidth) || 0) + (Number.parseFloat(style.borderBottomWidth) || 0);
	const outside = style.boxSizing === 'border-box' ? padding + border : 0;
	element.style.height = 'auto';
	const content = element.scrollHeight - padding;
	const height = Math.min(content, lineHeight * maxLines);
	element.style.height = `${height + outside}px`;
	element.style.overflowY = content > height + 1 ? 'auto' : 'hidden';
}
